<template>
  <section>
    <header>Коммерческое предложение</header>
    <VFormItem
      label="НДС"
      layout="vertical"
    >
      <VSelectV2
        v-model="option.vatRateSeller"
        class="VAT-size-control"
        hide-clear-btn
        :data="$core.dictionaries.vatRates"
      />

      <VSelectV2
        v-model="localOptionIsVatIncludedSeller"
        class="include-VAT-control"
        hide-clear-btn
        placeholder="--"
        :data="$core.dictionaries.vatInclusionOptions"
      />
    </VFormItem>
  </section>

  <hr>

  <section>
    <VDateInput
      v-model="option.expirationDate"
      label="Партия годна до"
      layout="vertical"
      :validate-method="$event => option.validateExpirationDate($event)"
    />
  </section>

  <hr>

  <section>
    <VSelectV2
      v-model="option.package"
      layout="vertical"
      label-width="220px"
      label="Упаковка"
      hide-clear-btn
      :data="packageSource"
    >
      <template #option="{ option }">
        <div class="package-list-option">
          <b>{{ option.code }}</b>&nbsp;
          <span>{{ option.name }}</span>
        </div>
      </template>
    </VSelectV2>

    <VInputNumberRusV2
      v-model="option.packageVolume"
      label-width="220px"
      layout="vertical"
      label="Фасовка"
      :type="Qty"
      range="4.3"
    />
  </section>

  <hr>

  <PackageCharacteristics
    :order-option="option"
  />

  <hr>

  <section>
    <header>Параметры поставщика</header>

    <VTextarea
      v-model="option.description"
      layout="vertical"
      label="Описание"
    >
      <template #helper-text>
        Внесите дополнительные данные на ваше усмотрение - недостающую характеристику товара
        и
        её параметр или важную особенность товара, которая выделяет ваш товар из всех
        предложений
      </template>
    </VTextarea>
  </section>

  <hr>

  <section>
    <header>Условия перевозки</header>

    <VTemperatureRangeInput
      v-model="option.storeTemperatureRange"
      label="Температурный режим перевозки, °C"
      :precision="0"
      :min="-60"
      :max="70"
    />

    <VTextarea
      v-model="option.storeRulesText"
      label="Особые условия перевозки"
      layout="vertical"
      :max-length="300"
    />
  </section>

  <hr>

  <section>
    <VSelectV2
      v-model="option.buyer"
      label="Покупатель"
      layout="vertical"
      disabled
    />
    <VSelectV2
      v-model="option.buyerStore"
      label="Склад покупателя"
      layout="vertical"
      disabled
    />
  </section>
</template>

<script lang="ts">

import DemandOption            from '@/domains/DemandsV2/DemandOption';
import PackagesService         from '@/domains/Packages/PackagesService';
import Qty                     from '@/core/types/Qty';

import PackageCharacteristics  from '@/domains/Offers/components/PackageCharacteristics/PackageCharacteristics.vue';

export default defineComponent({
  name: 'DemandOptionSecondaryTab',

  components: {
    PackageCharacteristics,
  },

  props: {
    option: {
      type:    DemandOption,
      default: null,
    },
  },

  setup() {
    return {
      Qty,
    };
  },

  data() {
    return {
      /** Упаковка ищется по паттерну на бэке. Обёртка $core.loader.select не
       *  нужна: VSelectV2 сам заворачивает функцию в источник, а прелоада и
       *  зависимостей здесь нет. Держим в data(), чтобы ссылка не менялась
       *  на каждую перерисовку. */
      packageSource: ({ pattern }: { pattern?: string }) => PackagesService.getList( {pattern : pattern as string } ),
    };
  },

  computed: {
    /**
     * Признак «НДС включён». В модели boolean, в справочнике объект
     * { value, name } — отсюда переходник: VSelectV2 отдаёт наружу элемент
     * списка, а не его поле.
     *
     * Поиск делаем здесь, а не через DemandOption.selectedIsVatRateSellerOption:
     * тот помимо поиска подменял результат заглушкой { id: 0, name: '--' } —
     * объектом, которого в справочнике нет, да ещё и по состоянию соседнего
     * поля vatRateSeller. Прочерк при незаполненных данных — забота контрола.
     */
    localOptionIsVatIncludedSeller: {
      set(option: { value: boolean } | null): void {
        this.option.isVatIncludedSeller = option?.value ?? null;
      },
      get(): { value: boolean; name: string } | undefined {
        return this.$core.dictionaries.vatInclusionOptions
          .find((item: { value: boolean }) => item.value === this.option.isVatIncludedSeller);
      },
    },
  },
});
</script>
